import { DashboardApi20240730 } from '@sequencehq/api/dashboard/v20240730'
import { BillingSchedulePhaseWithParsedDates } from 'BillingScheduleHome/utils/useBillingScheduleAggregate'
import { atom } from 'jotai'

export type APIPrice = Exclude<
  DashboardApi20240730.GetPrice.Response['data'],
  null
>
export type APIDiscount = DashboardApi20240730.GetBillingSchedule.PhaseDiscount
export type APIMinimum = DashboardApi20240730.GetBillingSchedule.PhaseMinimum
export type APIPhase =
  DashboardApi20240730.GetBillingSchedule.BillingSchedulePhase

export type ProcessedPhase = {
  id: string
  startDate: Date
  endDate: Date
  openEnded: boolean
  prices: Array<APIPrice>
  discounts: Array<APIDiscount>
  minimums: Array<APIMinimum>
  name?: string
  recurrencePreference: APIPhase['recurrencePreference']
  recurrenceDayOfMonthForPhase: number
}

export type TimelineScheduleData = {
  startDate: Date
  endDate?: Date
  recurrenceDayOfMonth: number
  phases: Array<BillingSchedulePhaseWithParsedDates>
  prices: Array<APIPrice>
}

export const scheduleDataAtom = atom<TimelineScheduleData | null>(null)
